import { ID } from "common/entities/IEntity";
import { Entity, Field } from "typegraph";

@Entity({many: "creditTypes"})
export class CreditType {
	@Field()
	public id: string;

	@Field()
	public name: string;
}

export class CreditEntry {
	@Field()
	public id: string;

	@Field()
	public value: number;

	@Field()
	public granted: boolean;

	@Field({entity: CreditType})
	public type: CreditType;
}

export class CreditValid{
	@Field()
	public isValid: boolean;
}
// tslint:disable:max-classes-per-file
@Entity({update: "grantCredits"})
export class CreditEntryUpdate {

	// this is still an ActionResult

	@Field()
	public entityId: ID;

}


// WEBPACK FOOTER //
// ./src/panels/subscriptions/entities/CreditEntry.ts